// ─────────────────────────────────────────────────────────────────────────────
// Chroma-key do fundo branco das spritesheets (arte gerada com fundo claro).
// Fonte única: CombatGrid (sprites no mapa) e SpritePortrait (fim de batalha).
// ─────────────────────────────────────────────────────────────────────────────

/** Copia a imagem para um canvas com o fundo branco transparente (borda suavizada). */
export function keyOutWhite(img: HTMLImageElement): HTMLCanvasElement {
  const oc   = document.createElement('canvas');
  oc.width   = img.width;
  oc.height  = img.height;
  const octx = oc.getContext('2d')!;
  octx.drawImage(img, 0, 0);

  const imgData = octx.getImageData(0, 0, oc.width, oc.height);
  const d       = imgData.data;
  for (let i = 0; i < d.length; i += 4) {
    const r = d[i], g = d[i + 1], b = d[i + 2];
    if (r > 220 && g > 220 && b > 220) {
      d[i + 3] = 0;
    } else if (r > 190 && g > 190 && b > 190) {
      const brightness = (r + g + b) / 3;
      d[i + 3] = Math.round(Math.max(0, (220 - brightness) / 30) * 255);
    }
  }
  octx.putImageData(imgData, 0, 0);
  return oc;
}
